import Input from "../design/Input";
import { LuEye, LuEyeOff } from "react-icons/lu";
import FetchMassage from '../../faetures/FetchMassage';
import regx from '../../functions/regx';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';


function FromLogin({setForgetPasspord}) {
    const [formData, setFormData] = useState({user: '', password: '', office: localStorage.getItem('office_number')});
    const [fetchMassage, setFetchMassage] = useState({open: false, data: '', text: "", url: ""});
    const [shwoPassword, setShwoPassword] = useState(false);

    const Navigate = useNavigate();

    function check_server_response (resolve) {

        if (resolve[0] !== 'error') {
            resolve = resolve["data"];
            if (resolve['token']) {
                sessionStorage.setItem('token', resolve['token']);

                const date = new Date();
                date.setHours(1)
                document.cookie = 'token' + "=" + (resolve['token']) + date + "; path=/";
                Navigate('/');
    
                if (resolve['office']) {
                    localStorage.setItem('office_number', resolve['office']);
                } if (resolve['permissions']) {
                    sessionStorage.setItem('admin', resolve['permissions']);
                }
            } else {
                setFetchMassage({open: true, text: resolve});
            }
        } else {
            setFetchMassage({open: true, text: "שגיאה"});  
        }
    }
    
    const handleSubmit = (e) => {
        e.preventDefault();
        if (regx('^[0-9]+$', formData.office, false) && regx('passpord', formData.user, false) && regx('passpord-login', formData.password, false)) {
            setFetchMassage({open: true, url: 'login\\login', data: JSON.stringify(formData), text: ''});
        }
    };

    const ClickshwoPassword = (e) => {
        e.preventDefault();
        setShwoPassword(shwoPassword => !shwoPassword);
    }

    return (
        <div>
            <p>התחברות</p>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor='office'>קוד משרד</label>
                    <Input
                    name={'office'}
                    value={formData.office}
                    onChange={(e) => setFormData({...formData, office: e})}
                    pattern={'^[0-9]{7}$'}
                    myStyle={'form-control'}
                    textView={'קוד משרד'}
                    />
                </div>

                <div>
                    <label htmlFor='user'>שם משתמש</label>
                    <Input 
                    name={'user'} 
                    value={formData.user}
                    onChange={(e) => setFormData({...formData, user: e})}
                    language={'en'}
                    pattern={'passpord'}
                    myStyle={'form-control'}
                    textView={'שם משתמש'}
                    autoComplete={'username'} 
                    />
                </div>

                <div>
                    <label htmlFor='password'>סיסמה</label>
                    <div className={'shwo-password-login'}>
                        <Input
                        name={'password'}
                        onChange={(e) => setFormData({...formData, password: e})}
                        value={formData.password}
                        pattern={'passpord-login'}
                        myStyle={'form-control'}
                        type={shwoPassword ? 'text' : 'password'}
                        textView={'סיסמה'}
                        autoComplete={'current-password'}
                        />
                        {shwoPassword ? <LuEye fontSize={'14pt'} onClick={ClickshwoPassword} /> : <LuEyeOff fontSize={'14pt'} onClick={ClickshwoPassword} />}
                    </div>

                </div>
                <p className={'forget-password-login'} onClick={() => setForgetPasspord(true)}>שכחתי סיסמה</p>

                <button type="submit" className="submit-button">Login</button>

                {
                fetchMassage.open && 

                    <FetchMassage 
                    url={fetchMassage.url} 
                    data={fetchMassage.data} 
                    text={fetchMassage.text} 
                    fun={check_server_response}
                    setClose={() => setFetchMassage({open: false})}
                    setMassage={setFetchMassage}
                    />
                }
            </form>
        </div>
    )
}


export default FromLogin;